import { render, staticRenderFns } from "./CopyFieldV2.vue?vue&type=template&id=71ccce06&"
import script from "./CopyFieldV2.vue?vue&type=script&lang=js&"
export * from "./CopyFieldV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports